import { writable } from 'svelte/store';
import type { CommentAttrsArray } from './comment.type';
// CommentAttrs, NotificationAttrs

// Define initial state
const initialComments: { [postId: string]: CommentAttrsArray } = {};

// Create writable store for comments
export const commentStore = writable<{ [postId: string]: CommentAttrsArray }>(initialComments);

// Function to update comments for a specific post
export function updateCommentsForPost(postId: string, comments: CommentAttrsArray) {
	commentStore.update((store) => {
		store[postId] = comments;
		return store;
	});
}

// const commentSchema: CommentAttrs = {
// 	id: '',
// 	created_at: undefined,
// 	email: '',
// 	message: '',
// 	post_id: '',
// 	replied_to_username: '',
// 	author_username: '',
// 	created_by: '',
// 	notifications: [] as NotificationAttrs[]
// };

// export const commentStore = writable<CommentAttrs>(commentSchema);
// export const comments = writable<CommentAttrsArray>([commentSchema]);
// export const commentOwner = writable<boolean>(false);

// export const updateComments = (newComments: CommentAttrsArray) => {
// 	comments.set(newComments);
// };

// interface ReplyInfo {
// 	id?: string;
// 	message: string;
// 	author_username: string;
// }

// interface SelectedComment {
// 	replyInfo?: ReplyInfo;
// }

// class NotificationsStore {
// 	private selectedComment = writable<SelectedComment | null>(null);

// 	setSelectedCommentId() {
// 		// Set the selectedComment with the provided id and an initial replyInfo
// 		this.selectedComment.set({
// 			replyInfo: { id: '', message: '', author_username: '' }
// 		});
// 	}

// 	setReplyInfo(replyInfo: ReplyInfo) {
// 		this.selectedComment.update(() => ({ replyInfo }));
// 	}
// }

// export const notificationsStore = new NotificationsStore();
// export const selectedCommentStore = notificationsStore.selectedComment;
